import { type JSX,useEffect, useState } from 'react';
import * as React from 'react';

import Checkbox from '@mui/material/Checkbox';
import { CheckboxProps } from '@mui/material/Checkbox/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { GridFeatureMode } from '@mui/x-data-grid';
import { useAppSelector } from 'app/hooks';
import { DATA_GRID_FIRST_PAGE } from 'common/constants/pagination';
import { useUpdatePalmDataGridPage } from 'common/hooks/useUpdatePalmDataGridPage';

import { selectPaginationModel } from './PalmDataGrid/palmDataGridSlice';

export interface IDropdownOption {
    label: string;
    value?: string;
    color?: CheckboxProps['color'];
}

interface ICheckboxOption {
    option: IDropdownOption;
    checked?: boolean;
    paginationMode: GridFeatureMode;
    onCheckboxChange?: (label: string) => void;
}

export function CheckboxOption(props: Readonly<ICheckboxOption>): JSX.Element {

    const [isChecked, setIsChecked] = useState<boolean>(false);
    const { option, checked, onCheckboxChange } = props;
    const paginationModel = useAppSelector(selectPaginationModel);
    const { updatePalmDataGridPage } = useUpdatePalmDataGridPage();

    function onChange(event: React.ChangeEvent<HTMLInputElement>, newCheckedState: boolean): void {
        setIsChecked(newCheckedState);
        updatePalmDataGridPage(props.paginationMode, DATA_GRID_FIRST_PAGE, paginationModel);
        onCheckboxChange?.(option?.value ?? option.label);
    }

    useEffect(() => {
        if(checked) {
            setIsChecked(checked);
        }
    }, [checked]);

    return (
        <FormControlLabel
            control={
                <Checkbox
                    checked={isChecked}
                    color={option.color}
                    value={option?.value ?? option.label}
                    onChange={onChange}
                    data-testid={option?.value ?? option.label}
                />
            }
            label={option.label}
        />
    );

}
